module.exports = __webpack_public_path__ + "static/img/kp.35e33aa7.svg";